import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const WorldCup = loadable(() => pMinDelay(import('./WorldCup'), 300), {
  fallback: <Loading />
});

const AsyncWorldCup = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <WorldCup { ...props }/>
    </ApplicationLayout>
  );
};

AsyncWorldCup.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncWorldCup;
